import React from 'react';
import cx from 'classnames';

const CountLabel = ({count, active}) => (
  <span
    className={cx(
      active ? 'bg-purple-100 text-purple-600' : 'bg-gray-100 text-gray-900',
      'hidden ml-2 py-0.5 px-2.5 rounded-full text-xs font-medium md:inline-block',
    )}
  >
    {count}
  </span>
);

export const Tab = ({
  active, key, onClick, count, children, disabled,
}) => (
  <button
    type="button"
    key={key}
    onClick={onClick}
    disabled={disabled}
    className={cx(
      active
        ? 'border-indigo text-indigo'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200',
      'whitespace-nowrap py-2 px-1 border-b-2 font-medium text-base',
    )}
  >
    {children}
    {typeof count === 'number' && <CountLabel count={count} active={active} />}
  </button>
);

export const Tabs = ({
  tabs, active, onClick, className,
}) => (
  <div className={cx('border-b border-gray-200', className)}>
    <nav className="mt-2 -mb-px flex space-x-6" aria-label="Tabs">
      {tabs.map((tab) => (
        <Tab
          key={tab.key}
          onClick={() => onClick(tab.key)}
          active={active === tab.key}
          count={tab.count}
        >
          {tab.label}
        </Tab>
      ))}
    </nav>
  </div>
);
